<template>
  <div class="wrapper">
    <van-row class="bg">
      <van-row type="flex" justify="end">
      </van-row>
      <van-row class="balance">
        <img src="./../../assets/images/qbye@2x.png" alt="">
        <van-row>可用余额(元)</van-row>
        <span>{{money}}</span>
      </van-row>
    </van-row>
    <!--提现进度-->
    <van-row class="progress" v-if="progressinfo.type==1">
      <van-row class="title">提现进度</van-row>
      <van-row>
        <van-row class="time" type="flex" justify="space-between" align="center">
          <van-col>{{progressinfo.time}}</van-col>
          <van-col>{{progressinfo.status}}</van-col>
        </van-row>
        <van-row class="money" type="flex" justify="space-between" align="center">
          <van-col>¥{{progressinfo.money}}</van-col>
          <van-button round type="default" size="small" @click.native="cancel">取消提现</van-button>
        </van-row>
      </van-row>
    </van-row>
    <!--提现-->
    <div v-else>
      <van-row class="btn" type="flex" justify="center" align="center">
        <span>￥</span>
        <input type="text" placeholder=" 请输入整数提现金额" class="input" v-model="withdrawmoney" ref="input">
      </van-row>
      <van-row class="btn" type="flex" justify="center" align="center">
        <input type="text" placeholder=" 请输入提现微信号" class="leftinput" v-model="wechat">
        <div class="shuxian"></div>
        <van-row @click.native="withdraw">申请提现</van-row>
      </van-row>
    </div>
    <!--申请成功-->
    <van-popup v-model="show" :close-on-click-overlay=false>
      <van-row class="popup">
        <van-row class="title" type="flex" justify="center" align="center">申请成功</van-row>
        <van-row class="content" type="flex" justify="center" align="center">提现申请审核将在1-2小时内完成</van-row>
        <van-row>
          <van-col class="cancel" @click.native="show=false">确定</van-col>
        </van-row>
      </van-row>
    </van-popup>
  </div>
</template>

<script>
  import {checkempty} from "./../../assets/js/tool"
  import weChatShareApi from "../../assets/js/weChatShare";
  export default {
    components: {},
    props: {},
    mixins: [weChatShareApi],
    data() {
      return {
        show: false,
        money: "0.00",
        progressinfo: "",
        withdrawmoney: "",
        wechat: "",
        reg: /^-$|^-?\d+(\.\d+)?$/,
      }
    },
    watch: {
      withdrawmoney(val, old) {
        if(!val){
          return
        }
        if (this.reg.exec(val)) {
          this.$refs.input.value = val
        } else {
          val = val.substring(0, val.length - 1)
          this.$toast('提现金额请勿输入小数');
          this.$refs.input.value = val
        }
        if(Number(val)>Number(this.money)){
          val = Number(this.money).toFixed(0);
          this.$toast('提现金额请勿超出余额上限');
        }
        this.withdrawmoney = val
      }
    },
    methods: {
      withdraw() {
        const that = this;
        const arr = [
          {val: that.withdrawmoney, toast: "请输入提现金额"},
          {val: that.wechat, toast: '请输入提现微信号'},
        ];
        let result = true;
        for (var index = 0; index < arr.length; index++) {
          if (!checkempty(arr[index].val,arr[index].toast)) {
            result = false;
            break
          }
        }
        if (!result) {
          return
        }
        if(this.withdrawmoney == 0){
          this.$toast('提现金额不能为0');
          return
        }
        that.$post('/api/my/withdraw_deposit', {
          user_id: this.userInfo.id,
          money: that.withdrawmoney,
          wechat: that.wechat,
          type2: 0,
          type1: 0,
        }).then(res => {
          console.log(res);
          if (res.code == 1) {
            this.withdrawmoney ="";
            this.wechat = "";
            this.show = true;
            this.getdata();
          }else{
            this.$toast(res.msg);
          }
        })
      },
      /**
       * 取消提现
       */
      cancel() {
        this.$post('/api/my/withdraw_cancel', {id: this.progressinfo.id}).then(res => {
          this.$toast(res.msg);
          if (res.code == 1) {
            this.getdata();
          }
        })
      },
      getdata() {
        this.$post('/api/my/withdraw_deposit_list', {id: this.userInfo.id,type:1}).then(res => {
          if (res.code == 1) {
            this.progressinfo = res.data;
            this.money = res.data.balance;
          } else {
            this.$toast(res.msg);
          }
        })
      },
      initPage(){
        this.getdata();
        let option = {
          title: '有米@'+this.userInfo.name+'的店铺',
          desc: "欢迎光临我的店铺",
          link: location.origin + "/?supNbr=" + this.userInfo.nbr,
          images: this.userInfo.imgUrl,
        };
       this.weChatShare(option)
      }
    },
    created() {
      document.title = '提现';
      this.initPage()
    },
    mounted() {
    }
  }
</script>
<style scoped lang='stylus'>
</style>
<style scoped lang='less'>
  .wrapper {
    width: 100%;
    background: #F5F5F5;
    min-height: 100vh;
    overflow: hidden;
  }

  .bg {
    height: 7.88rem;
    background-image: linear-gradient(0deg, #FE6664 0%, #E52B25 100%);
    padding-top: 1.56rem;
    .balance {
      margin: 0 auto 0;
      position: relative;
      width: 4.74rem;
      height: 4.44rem;
      text-align: center;
      color: #FFFFFF;
      .van-row {
        position: absolute;
        top: -0.14rem;
        left: 0;
        width: 100%;
        font-size: 0.28rem;
      }
      span {
        font-size: 0.68rem;
        margin-top: 1.46rem;
        display: inline-block;
      }
      img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
      }
    }

  }

  .btn {
    padding: 0 0.4rem;
    margin: -0.6rem auto 1rem;
    box-sizing: border-box;
    width: 6.94rem;
    height: 1.2rem;
    background: #ffffff;
    border-radius: 0.64rem;
    line-height: 1.2rem;
    font-size: 0.32rem;
    color: #333333;
    position: relative;
    display: flex;
    .input {
      width: 5.5rem;
      height: 100%;
      border: none;
    }
    .leftinput {
      border: none;
      width: 4rem;
    }
    .van-row {
      display: inline-block;
      margin-left: 0.5rem;
      color: #E52B25;
    }
    .shuxian {
      position: absolute;
      right: 2.3rem;
      top: 0.28rem;
      display: inline-block;
      height: 0.64rem;
      width: 1px;
      background: #EBEBEB;
    }
  }

  .progress {
    height: 2.86rem;
    width: 6.94rem;
    margin: -0.92rem auto 0;
    background: #ffffff;
    box-shadow: 0 0.12rem 0.24rem 0 rgba(242, 242, 242, 0.50);
    border-radius: 0.2rem;
    padding: 0 0.24rem;
    box-sizing: border-box;
    .title {
      height: 0.92rem;
      border-bottom: 1px solid #ebebeb;
      line-height: 0.92rem;
      font-size: 0.32rem;
      color: #333333;
    }
    .time {
      margin-top: 0.3rem;
      .van-col:nth-child(1) {
        font-size: 12px;
        color: #999999;
      }
      .van-col:nth-child(2) {
        font-size: 0.24rem;
        color: #5045D8;
      }
    }
    .money {
      margin-top: 0.4rem;
      .van-col {
        font-size: 0.36rem;
        color: #151515;
      }
      .van-button {
        width: 1.68rem;
        font-size: 0.28rem;
        color: #666666;
      }
    }
  }

  /*申请成功*/
  .van-popup {
    border-radius: 0.4rem;
    .popup {
      width: 5.18rem;
      height: 2.24rem;
      .title {
        font-size: 0.32rem;
        color: #333333;
        margin-top: 0.6rem;
        margin-bottom: 0.2rem;
      }
      .content {
        /*height: 1.6rem;*/
        text-align: center;
        font-size: 0.28rem;
        color: #999999;
        margin-bottom: 0.6rem;
      }

    }
    .cancel {
      height: 0.96rem;
      text-align: center;
      line-height: 0.96rem;
      width: 100%;
      background: #F5F5F5;
      font-size: 0.32rem;
      color: #333333;
      border-right: 1px solid #ebebeb;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/information/withdrawcash.vue